import { createFileRoute, useRouteContext } from '@tanstack/react-router';
import { Flex } from 'antd';

import { AgentConfigCard } from '../../../../../modules/ai-agent/components/agent-config-card';
import { AgentSteps } from '../../../../../modules/ai-agent/components/agent-steps';
import { useGetAiAgentQuery } from '../../../../../modules/ai-agent/hooks';

const AgentPreviewRoute = () => {
  const { selectedOrganization } = useRouteContext({ from: '/_authenticated/_app' });
  const { agentId } = Route.useParams();

  const { data: agentResponse } = useGetAiAgentQuery(selectedOrganization.id, agentId);
  const agentData = agentResponse?.data;

  if (!agentData) return null;

  return (
    <Flex vertical flex={1} align="center" style={{ padding: '24px 24px 0' }}>
      <Flex vertical gap={42} style={{ maxWidth: 680 }}>
        <AgentConfigCard organizationId={selectedOrganization.id} agent={agentData} />
        <AgentSteps
          organizationId={selectedOrganization.id}
          aiAgentId={agentData.id}
          aiAssistantThreadId={agentData.builtInAssistantThread?.id}
          agentGoal={agentData.goal}
          steps={agentData.steps}
          executorSender={agentData.executorSender}
        />
      </Flex>
    </Flex>
  );
};

export const Route = createFileRoute('/_authenticated/_app/agents/$agentId/')({
  component: AgentPreviewRoute,
});
